import { motion } from 'framer-motion/dist/framer-motion';
import React, { useState } from "react";
import moon from '../../assets/images/moon.png';
import sun from '../../assets/images/sun.png';
const svgVariants = {
    hidden: {
        rotate: 0
    },
    visible: {
        rotate: 0,
        transition: {
            duration: 2
        }
    }
}

const pathVariants = {
    hidden: {
        opacity: 1,
        pathLength: 0
    },
    visible: {
        opacity: 1,
        pathLength: 1,
        transition: {
            duration: 4,
            ease: "easeIn"
        }
    }
}

const Header = props => {

    const [navMenu, setNavMenu] = useState({
        navigationMenu: "nav__menu",
    })

    const [darkMode, setDarkMode] = useState({
        theme: 'day',
    })

    const navMenuOpenHandler = () => {
        setNavMenu({
            navigationMenu: "nav__menu show-menu"
        })
    }

    const navMenuCloseHandler = () => {
        setNavMenu({
            navigationMenu: "nav__menu"
        })
    }

    const linkAction = () => {
        setNavMenu({
            navigationMenu: "nav__menu"
        })
    }

    const scrollActive = () => {
        const sections = document.querySelectorAll('section[id]')
        const scrollY = window.pageYOffset

        sections.forEach(current => {
            console.log('hello world')
            const sectionHeight = current.offsetHeight
            const sectionTop = current.offsetTop - 50;
            const sectionId = current.getAttribute('id')

            if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
                document.querySelector('.nav__menu a[href*=' + sectionId + ']').classList.add('active-link')
            } else {
                document.querySelector('.nav__menu a[href*=' + sectionId + ']').classList.remove('active-link')
            }
        })
    }
    window.addEventListener('scroll', scrollActive)

    function changeHeaderColor() {
        const header = document.getElementById('header');
        const darkHeader = 'colourful__dark__header'
        const lightHeader = 'colourful__light__header'
        // When the scroll is higher than 100 viewport height, add the colourful class to the a tag with the colourful__header class
        if (darkMode.theme === 'night') {
            if (header.classList.contains(lightHeader)) {
                header.classList.remove(lightHeader)
                if (this.scrollY >= 100) header.classList.add(darkHeader); else header.classList.remove(darkHeader)
            }
            else {
                if (this.scrollY >= 100) header.classList.add(darkHeader); else header.classList.remove(darkHeader)
            }
        }
        else {
            if (header.classList.contains(darkHeader)) {
                header.classList.remove(darkHeader)
                if (this.scrollY >= 100) header.classList.add(lightHeader); else header.classList.remove(lightHeader)
            }
            else {
                if (this.scrollY >= 100) header.classList.add(lightHeader); else header.classList.remove(lightHeader)
            }
        }
    }
    window.addEventListener('scroll', changeHeaderColor)

    const darkThemeHandler = () => {

        const header = document.getElementById('header');
        const darkHeader = 'colourful__dark__header'
        const lightHeader = 'colourful__light__header'

        console.log(darkMode.theme)
        if (darkMode.theme === 'night') {
            if (document.body.classList.contains('dark-theme')) {
                console.log('sun clicked')
                document.body.classList.remove('dark-theme')

                if (header.classList.contains(darkHeader)) {
                    header.classList.remove(darkHeader)
                    if (window.scrollY >= 100) header.classList.add(lightHeader); else header.classList.remove(lightHeader)
                }
                else {
                    if (window.scrollY >= 100) header.classList.add(lightHeader); else header.classList.remove(lightHeader)
                }

                setDarkMode({
                    theme: 'day'
                })
            }
        }

        else {
            if (document.body.classList.contains('dark-theme') === false) {
                console.log('moon clicked')
                document.body.classList.add('dark-theme')

                if (header.classList.contains(lightHeader)) {
                    header.classList.remove(lightHeader)
                    if (window.scrollY >= 100) header.classList.add(darkHeader); else header.classList.remove(darkHeader)
                }
                else {
                    if (window.scrollY >= 100) header.classList.add(darkHeader); else header.classList.remove(darkHeader)
                }

                setDarkMode({
                    theme: 'night'
                })
            }
        }


        // })

    }

    return (
        <header class="header" id="header">
            <nav class="nav container">

                <motion.div className="logo"
                    drag
                    dragConstraints={{ top: 0, right: 0, left: 0, bottom: 0 }}
                    dragElastic={0.8}

                >
                    <motion.svg style={{ paddingTop: '17px' }} className="pizza-svg nav__logo"
                        variants={svgVariants}
                        initial="hidden"
                        animate="visible"
                        whileHover={{ scale: 1.5 }}
                        width="1.1in"
                        height="0.577778in"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99 52">
                        <motion.path
                            id="sourav__path"
                            variants={pathVariants}
                            fill="none"
                            stroke="var(--title-color)"
                            strokeWidth="1"
                            d="M 76.11,39.25
                        C 77.14,37.85 78.06,36.50 78.86,35.21
                          79.32,34.45 80.54,32.38 82.52,29.01
                          82.52,29.01 84.79,25.16 84.79,25.16
                          86.47,22.31 87.58,20.49 88.14,19.70
                          89.04,18.35 89.94,17.68 90.84,17.68
                          91.48,17.68 91.80,17.94 91.80,18.45
                          91.80,18.80 91.67,19.25 91.42,19.78
                          91.25,20.15 90.75,21.44 89.93,23.63
                          89.11,25.87 88.47,28.36 88.03,31.11
                          87.71,33.07 87.55,34.74 87.55,36.12
                          87.55,36.53 87.57,36.98 87.60,37.48
                          87.65,37.96 87.73,38.50 87.82,39.09
                          88.53,38.16 89.31,36.83 90.17,35.10
                          90.99,33.36 92.25,30.60 93.96,26.82
                          95.59,23.20 97.48,19.44 99.66,15.55
                          101.44,12.33 103.57,9.08 106.05,5.80
                          107.21,4.25 108.13,3.47 108.83,3.47
                          109.13,3.47 109.41,3.63 109.66,3.94
                          109.84,4.16 109.93,4.41 109.93,4.69
                          109.93,5.06 109.37,5.97 108.27,7.43
                          106.09,10.29 104.02,13.46 102.04,16.93
                          99.77,20.96 96.94,26.68 93.54,34.10
                          92.02,37.42 90.86,39.79 90.06,41.19
                          89.22,42.63 88.26,43.35 87.17,43.35
                          86.25,43.35 85.55,42.94 85.09,42.10
                          84.62,41.26 84.39,40.00 84.39,38.34
                          84.39,35.66 84.82,32.35 85.68,28.40
                          84.84,29.49 83.86,31.03 82.74,33.02
                          81.90,34.50 81.09,35.92 80.30,37.29
                          79.16,39.26 78.40,40.59 78.03,41.27
                          77.46,42.33 76.87,43.16 76.27,43.77
                          75.82,44.21 75.29,44.43 74.69,44.43
                          73.96,44.43 73.43,44.11 73.11,43.46
                          72.88,43.02 72.76,42.47 72.76,41.83
                          72.76,37.43 74.99,29.56 79.45,18.20
                          81.62,12.65 82.89,9.24 83.24,7.98
                          83.56,6.77 83.88,5.99 84.21,5.66
                          84.63,5.18 85.13,4.94 85.70,4.94
                          86.49,4.94 86.88,5.33 86.88,6.10
                          86.88,7.04 86.54,8.47 85.86,10.39
                          85.10,12.57 83.87,15.66 82.17,19.64
                          81.02,22.40 80.20,24.45 79.71,25.82
                          77.54,32.61 76.34,37.09 76.11,39.25
                          76.11,39.25 76.11,39.25 76.11,39.25 Z
                        M 63.01,18.57
                        C 64.20,19.09 65.04,19.67 65.54,20.31
                          66.28,21.22 66.64,22.49 66.64,24.11
                          66.64,28.13 65.02,31.98 61.76,35.67
                          58.50,39.36 55.15,41.21 51.71,41.21
                          49.59,41.21 47.87,40.30 46.54,38.48
                          45.59,37.17 45.11,35.72 45.11,34.12
                          45.11,31.51 46.09,30.21 48.04,30.21
                          49.20,30.21 49.78,30.66 49.78,31.57
                          49.78,31.77 49.76,32.03 49.71,32.35
                          49.64,32.77 49.60,33.18 49.60,33.60
                          49.60,34.76 49.88,35.65 50.42,36.26
                          51.04,36.93 51.77,37.26 52.60,37.26
                          54.62,37.26 56.79,35.79 59.12,32.86
                          61.33,30.06 62.44,27.39 62.44,24.85
                          62.44,23.57 62.14,22.56 61.55,21.82
                          60.90,21.04 60.01,20.64 58.87,20.64
                          58.42,20.64 57.97,20.72 57.52,20.86
                          56.97,21.04 56.56,21.12 56.27,21.12
                          55.58,21.12 55.24,20.64 55.24,19.68
                          55.24,18.84 55.51,18.15 56.06,17.61
                          56.37,17.29 57.02,17.00 58.02,16.73
                          59.99,16.21 61.67,15.50 63.04,14.59
                          63.92,13.99 64.62,13.21 65.15,12.22
                          65.41,11.70 65.54,11.16 65.54,10.60
                          65.54,9.88 65.35,9.35 64.97,9.01
                          64.61,8.66 64.05,8.49 63.29,8.49
                          62.01,8.49 60.68,8.84 59.30,9.53
                          58.94,9.70 58.10,10.20 56.77,11.04
                          56.41,11.29 56.02,11.41 55.59,11.41
                          54.79,11.41 54.38,10.95 54.38,10.04
                          54.38,9.23 54.98,8.38 56.16,7.50
                          58.94,5.45 61.67,4.43 64.33,4.43
                          65.92,4.43 67.26,4.94 68.35,5.94
                          69.52,7.03 70.10,8.32 70.10,9.82
                          70.10,11.82 69.27,13.69 67.61,15.43
                          66.70,16.42 65.17,17.47 63.01,18.57
                          63.01,18.57 63.01,18.57 63.01,18.57 Z
                        M 29.98,28.12
                        C 27.64,32.81 26.02,36.56 25.11,39.36
                          24.58,40.99 24.21,41.89 24.01,42.08
                          23.76,42.34 23.38,42.46 22.86,42.46
                          22.44,42.46 22.11,42.32 21.87,42.02
                          21.66,41.74 21.55,41.46 21.55,41.16
                          21.55,40.30 22.36,37.99 23.96,34.24
                          25.10,31.54 26.62,28.48 28.51,25.04
                          28.26,24.20 28.13,23.55 28.13,23.11
                          28.13,22.48 28.36,21.98 28.83,21.61
                          29.06,21.43 29.31,21.33 29.57,21.33
                          29.82,21.33 30.14,21.43 30.54,21.61
                          30.80,21.13 31.79,19.37 33.50,16.32
                          35.04,13.24 35.88,11.43 36.04,10.89
                          35.56,11.11 35.18,11.31 34.89,11.47
                          34.59,11.64 34.35,11.72 34.17,11.72
                          33.94,11.72 33.75,11.59 33.58,11.34
                          33.46,11.13 33.40,10.90 33.40,10.64
                          33.40,9.72 33.99,8.91 35.19,8.21
                          36.03,7.71 36.85,7.29 37.65,6.96
                          37.88,6.09 38.07,5.52 38.21,5.24
                          38.46,4.74 38.86,4.50 39.41,4.50
                          40.02,4.50 40.54,4.85 40.99,5.55
                          41.83,5.29 42.62,5.10 43.37,4.97
                          44.14,4.84 44.86,4.77 45.54,4.77
                          47.60,4.77 49.17,5.38 50.24,6.60
                          51.26,7.76 51.76,9.18 51.76,10.84
                          51.76,13.55 50.74,16.12 48.69,18.54
                          46.77,20.79 44.20,22.52 40.99,23.72
                          38.53,24.64 36.11,25.10 33.72,25.10
                          33.31,25.10 32.68,25.07 31.85,25.02
                          32.13,26.14 32.52,27.27 33.00,28.40
                          33.83,30.22 35.03,32.85 36.58,36.26
                          37.02,37.17 37.76,38.46 38.77,40.14
                          39.04,40.58 39.17,40.99 39.17,41.36
                          39.17,41.71 38.98,42.04 38.58,42.35
                          38.17,42.65 37.83,42.80 37.54,42.80
                          37.10,42.80 36.62,42.31 36.12,41.33
                          35.88,40.87 35.56,40.30 35.19,39.61
                          33.82,37.27 32.08,33.44 29.98,28.12 Z
                        M 33.24,22.14
                        C 33.91,22.17 34.42,22.19 34.76,22.19
                          38.45,22.19 41.90,20.85 45.11,18.18
                          46.52,16.99 47.66,15.63 48.53,14.08
                          49.08,13.12 49.36,12.10 49.36,11.03
                          49.36,9.94 49.02,9.13 48.34,8.59
                          47.68,8.04 46.69,7.76 45.35,7.76
                          44.14,7.76 42.92,8.00 41.69,8.48
                          41.20,8.67 40.52,8.97 39.63,9.40
                          39.00,10.87 37.99,13.02 36.58,15.82
                          35.17,18.61 34.06,20.72 33.24,22.14 Z
                        M 22.12,4.69
                        C 23.31,4.69 24.23,5.13 24.87,6.02
                          25.39,6.72 25.64,7.57 25.64,8.57
                          25.64,10.36 25.07,12.40 23.91,14.69
                          22.89,16.66 21.63,18.43 20.11,20.00
                          19.11,21.02 18.33,21.53 17.76,21.53
                          17.38,21.53 17.04,21.33 16.71,20.95
                          16.48,20.67 16.37,20.36 16.37,20.00
                          16.37,19.36 16.91,18.62 18.00,17.79
                          19.53,16.61 20.75,15.31 21.66,13.91
                          23.00,11.88 23.67,10.16 23.67,8.76
                          23.67,8.19 23.54,7.76 23.29,7.49
                          23.06,7.21 22.70,7.07 22.22,7.07
                          21.24,7.07 19.85,7.81 18.05,9.29
                          16.00,10.95 13.84,13.21 11.55,16.07
                          8.65,19.71 6.44,23.29 4.92,26.82
                          3.36,30.47 2.57,33.59 2.57,36.18
                          2.57,37.42 2.92,38.47 3.61,39.34
                          4.38,40.31 5.32,40.80 6.42,40.80
                          8.35,40.80 10.77,39.25 13.69,36.15
                          14.57,35.21 15.63,33.84 16.88,32.05
                          17.70,30.91 18.22,30.09 18.45,29.61
                          18.72,29.08 19.03,28.81 19.39,28.81
                          19.78,28.81 19.98,29.01 19.98,29.39
                          19.98,30.22 18.98,32.09 16.98,34.99
                          15.32,37.41 13.50,39.38 11.50,40.91
                          9.26,42.63 7.13,43.49 5.14,43.49
                          3.05,43.49 1.44,42.52 0.30,40.58
                          -0.43,39.34 -0.80,37.93 -0.80,36.34
                          -0.80,32.36 1.02,27.32 4.66,21.25
                          7.76,16.08 11.03,11.92 14.47,8.76
                          17.45,6.05 19.99,4.69 22.12,4.69 Z"
                        />
                    </motion.svg>

                </motion.div>

                {/* <a href="#home" class="nav__logo">
                </a> */}

                <div class={navMenu.navigationMenu} id="nav-menu">

                    <ul class="nav__list grid">
                        <li class="nav__item">
                            <a href="#home" class="nav__link active-link" onClick={linkAction}>
                                <i class="uil uil-estate nav__icon"></i> Home
                            </a>
                        </li>
                        <li class="nav__item">
                            <a href="#about" class="nav__link" onClick={linkAction}>
                                <i class="uil uil-user nav__icon"></i> About
                            </a>
                        </li>
                        <li class="nav__item">
                            <a href="#skills" class="nav__link" onClick={linkAction}>
                                <i class="uil uil-file-plus-alt nav__icon"></i> Skills
                            </a>
                        </li>
                        <li class="nav__item">
                            <a href="#qualification" class="nav__link" onClick={linkAction}>
                                <i class="uil uil-graduation-cap nav__icon"></i>Qualification
                            </a>
                        </li>
                        <li class="nav__item">
                            <a href="#services" class="nav__link" onClick={linkAction}>
                                <i class="uil uil-briefcase-alt nav__icon"></i> Services
                            </a>
                        </li>
                        <li class="nav__item">
                            <a href="#portfolio" class="nav__link" onClick={linkAction}>
                                <i class="uil uil-scenery nav__icon"></i> Portfolio
                            </a>
                        </li>
                        <li class="nav__item">
                            <a href="#contact" class="nav__link" onClick={linkAction}>
                                <i class="uil uil-message nav__icon"></i> Contactme
                            </a>
                        </li>
                    </ul>
                    <i class="uil uil-times nav__close" id="nav-close" onClick={navMenuCloseHandler}></i>
                </div>

                <div class="nav__btns">
                    {/* <!-- Theme change button --> */}
                    {/* <i class="uil uil-moon change-theme" id="theme-button" onClick={darkThemeHandler}></i> */}
                    {darkMode.theme === 'night' ? <img src={sun} class="uil uil-moon change-theme" id="theme-button" onClick={darkThemeHandler} alt="alternatetext" /> : <img src={moon} class="uil uil-moon change-theme" id="theme-button" onClick={darkThemeHandler} alt="alternatetext" />
                    }

                    <div class="nav__toggle" id="nav-toggle" onClick={navMenuOpenHandler}>
                        <i class="uil uil-apps"></i>
                    </div>

                </div>


            </nav>
        </header >

    )
}

export default Header